import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "wheelFilled"
const WheelFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 1.313C17.903 1.313 22.688 6.097 22.688 12S17.903 22.688 12 22.688 1.313 17.903 1.313 12 6.097 1.313 12 1.313M3.67 9.122C3.36 10.025 3.188 10.993 3.188 12 3.188 16.357 6.349 19.972 10.503 20.683Q10.5 20.653 10.5 20.625V15.641C9.07 15.05 8.063 13.643 8.063 12Q8.063 11.776 8.086 11.56L3.777 9.19Q3.722 9.159 3.67 9.123M20.25 8.969 15.902 11.478Q15.936 11.734 15.938 12C15.938 13.643 14.93 15.05 13.5 15.64V20.626Q13.499 20.655 13.496 20.683C17.65 19.973 20.813 16.357 20.813 12 20.813 10.93 20.62 9.904 20.27 8.955zM12 9.938C10.86 9.938 9.938 10.86 9.938 12 9.938 13.14 10.86 14.063 12 14.063 13.14 14.063 14.063 13.139 14.063 12S13.139 9.938 12 9.938M12 3.188C9.211 3.188 6.726 4.485 5.112 6.507Q5.168 6.532 5.222 6.56L9.533 8.931C10.208 8.389 11.066 8.064 12 8.064 12.904 8.063 13.736 8.368 14.4 8.88L18.75 6.37 18.77 6.36C17.153 4.422 14.72 3.187 12 3.187"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default WheelFilledIcon
